import { RouteObject } from 'react-router'
import { IS_CROSS_REFERENCE_FLOW_ENABLED } from '../../config/ConfigManager'
import { RootLayout } from './RootLayout'
import { PublicLayout } from './PublicLayout'
import { AppLayout } from './AppLayout'
import {
  Login,
  SendCode,
  ResetPassword,
  ContactAdmin,
  AutoLogin,
  Home,
  PartsCatalog,
  AstPartsCatalog,
  Cart,
  SearchResults,
  VehicleHistory,
  OrderHistory,
  QuotesPage,
  QuotesDetails,
  Lists,
  ProductDetails,
  OrderDetails,
  OrderConfirmation,
  CrossReferencePage,
  NotFoundPage,
} from './RoutesExports'
import RootErrorBoundary from './RootErrorBoundary'

export const routeData: RouteObject[] = [
  {
    element: <RootLayout />,
    ErrorBoundary: RootErrorBoundary,
    path: '/',
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: 'login', element: <Login /> },
          { path: 'sendCode', element: <SendCode /> },
          { path: 'resetPassword', element: <ResetPassword /> },
          { path: 'contactAdmin', element: <ContactAdmin /> },
          { path: 'auto-login', element: <AutoLogin /> },
        ],
      },
      {
        element: <AppLayout />,
        children: [
          {
            path: 'home',
            element: <Home />,
          },
          { path: 'partsCatalog', element: <PartsCatalog /> },
          { path: 'astPartsCatalog', element: <AstPartsCatalog /> },
          { path: 'cart', element: <Cart /> },
          { path: 'searchResults', element: <SearchResults /> },
          { path: 'vehicleHistory', element: <VehicleHistory /> },
          { path: 'orderHistory', element: <OrderHistory /> },
          {
            path: 'quotes',
            element: <QuotesPage />,
          },
          {
            path: 'quotes-details/:id',
            element: <QuotesDetails />,
          },
          { path: 'lists', element: <Lists /> },
          { path: 'product', element: <ProductDetails /> },
          {
            path: 'orderDetails/:orderId/*',
            element: <OrderDetails />,
          },
          { path: 'orderConfirmation', element: <OrderConfirmation /> },
          ...(IS_CROSS_REFERENCE_FLOW_ENABLED
            ? [
                {
                  path: 'cross-reference',
                  element: <CrossReferencePage />,
                },
              ]
            : []),
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]
